import { render, staticRenderFns } from "./NoteActivity.vue?vue&type=template&id=ba15c85e&"
import script from "./NoteActivity.vue?vue&type=script&lang=js&"
export * from "./NoteActivity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports